import ANSWERS_TYPES from './types';
import { type IAnswer, type IUserAnswer } from 'src/models';

function saveEdition(questionId: number, answers: IAnswer[]) {
	return {
		type: ANSWERS_TYPES.SAVE_EDITION,
		payload: { questionId, answers },
	};
}

function saveUserCourseAnswers(
	userAnswers: IUserAnswer[],
	courseId: number,
	userId: string,
) {
	return {
		type: ANSWERS_TYPES.SAVE_USER_COURSE_ANSWERS,
		payload: { userAnswers, courseId, userId },
	};
}

function saveUserSectionAnswers(
	userAnswers: IUserAnswer[],
	sectionId: number,
	userId: string,
) {
	return {
		type: ANSWERS_TYPES.SAVE_USER_SECTION_ANSWERS,
		payload: { userAnswers, sectionId, userId },
	};
}

function updateUserSectionAnswers(
	userAnswers: IUserAnswer[],
	sectionId: number,
	userId: string,
	courseId: string,
) {
	return {
		type: ANSWERS_TYPES.UPDATE_USER_SECTION_ANSWERS,
		payload: { userAnswers, sectionId, userId, courseId },
	};
}

const answerActions = {
	saveEdition,
	saveUserCourseAnswers,
	saveUserSectionAnswers,
	updateUserSectionAnswers,
};

export default answerActions;
